import { render, staticRenderFns } from "./2.vue?vue&type=template&id=26510652&scoped=true"
import script from "./2.vue?vue&type=script&lang=js"
export * from "./2.vue?vue&type=script&lang=js"
import style0 from "./2.vue?vue&type=style&index=0&id=26510652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26510652",
  null
  
)

export default component.exports